import { useEffect, useMemo } from 'react';
import { useNavigation, useProvider, useHasAccess } from '~/Hooks';
import { routeReplacer } from '~/Helpers/String.helper';
import { Route } from '~/Constants/Routes.constants';
import { useLocalStorage } from '~/Hooks/useLocalStorage';

export const ExportRedirect = () => {
  const { navigate } = useNavigation();
  const { currentProvider } = useProvider();
  const { accessToken } = useLocalStorage();
  const { hasAccess } = useHasAccess();
  const isAuthorized = useMemo(() => hasAccess(Route.EXPORT_PAGE), [hasAccess]);
  const isLoggedIn = useMemo(() => !!accessToken, [accessToken]);
  useEffect(() => {
    if (currentProvider?.domain) {
      if (!isAuthorized) {
        navigate(Route.HOME);
        return;
      }
      navigate(routeReplacer(Route.EXPORT_PAGE, { domain: currentProvider.domain }));
    } else if (!isLoggedIn) {
      navigate(Route.HOME);
    }
  }, [currentProvider?.domain, navigate, isLoggedIn, isAuthorized]);

  return null; // or a spinner/loading
};
